import React from "react";
import BasicModal from "@components/modal/BasicModal";
import styled from "@emotion/styled";
import Image from "@components/item/Image";
import { useTheme } from "@emotion/react";

const Container = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  fontSize: "1.4rem",
  lineHeight: "2.4rem",
  color: theme.color.gray,
  fontWeight: theme.fontWeight.regular,
  fontFamily: "Pretendard",

  ".title": {
    fontSize: "1.6rem",
    fontWeight: theme.fontWeight.bold,
    marginBottom: "2rem",
    color: theme.color.black,
  },

  ".warning": {
    display: "flex",
    justifyContent: "center",
    padding: "2rem",
  },
}));

type Props = {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
};
const PhotoModal = ({ open, setOpen }: Props) => {
  const theme = useTheme();

  return (
    <BasicModal
      noButton
      open={open}
      setOpen={setOpen}
      activeEvent={() => setOpen(false)}
      closeIcon
      title="상품사진등록"
      padding="">
      <Container>
        <span className="warning">
          <Image src={theme.image.warning_circle_thin.default} size="4.8rem" />
        </span>
        <span className="title">{"안내사항"}</span>

        <p>
          {
            "• 셀러가 등록 시 즉시 판매가 시작되나 관리자 재량에 따라 사진 교체 및 순서가 교체될 수 있습니다."
          }
        </p>

        <p>
          {
            "• B급상품(하자) 판매 시, 하자 부분 사진을 잘보이게 업로드해주셔야 교환/반품/환불 등 분쟁의 소지가 현저히 줄어듭니다."
          }
        </p>
      </Container>
    </BasicModal>
  );
};

export default PhotoModal;
